<template>
  <header class="top-nav">
    <img src="/img/main_logo.png" alt="Rafaela Vieira Lashes" width="180" />
  </header>
</template>

<script>
export default {
  name: 'Navbar',
};
</script>
